import { Switch, Route } from "wouter";
import NotFound from "@/pages/not-found";

import { RootLayout } from "@/components/layout/RootLayout";
import { AdminLayout } from "@/components/layout/AdminLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Work from "@/pages/Work";
import WorkDetail from "@/pages/WorkDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Help from "@/pages/Help";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import TTFBAudit from "@/pages/TTFBAudit";

// Admin
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import Blogs from "@/pages/admin/Blogs";
import BlogEditor from "@/pages/admin/BlogEditor";
import Projects from "@/pages/admin/Projects";
import AdminServices from "@/pages/admin/Services";
import AdminTestimonials from "@/pages/admin/Testimonials";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/common/ScrollToTop";

import { HelmetProvider } from "react-helmet-async";
import { CookieBanner } from "@/components/common/CookieBanner";

function App({ helmetContext, url }: { helmetContext?: any, url?: string }) {
  return (
    <HelmetProvider context={helmetContext}>
      <ScrollToTop />
      <Switch>
      {/* 1. Admin Login (No Layout) */}
      <Route path="/ab-hq/login" component={AdminLogin} />

      {/* 2. Admin Section (With AdminLayout & AuthGuard) */}
      <Route path="/ab-hq">
        <AuthGuard>
          <AdminLayout>
            <Dashboard />
          </AdminLayout>
        </AuthGuard>
      </Route>

      {/* 3. Sub-Admin Routes */}
      <Route path="/ab-hq/leads"><AuthGuard><AdminLayout><Leads /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/blogs"><AuthGuard><AdminLayout><Blogs /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/blogs/new"><AuthGuard><AdminLayout><BlogEditor /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/blogs/:id/edit"><AuthGuard><AdminLayout><BlogEditor /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/projects"><AuthGuard><AdminLayout><Projects /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/services"><AuthGuard><AdminLayout><AdminServices /></AdminLayout></AuthGuard></Route>
      <Route path="/ab-hq/testimonials"><AuthGuard><AdminLayout><AdminTestimonials /></AdminLayout></AuthGuard></Route>

      {/* 4. Public Section (With RootLayout) */}
      <Route>
        <RootLayout>
          <Switch>
            <Route path="/" component={Home} />
            <Route path="/about" component={About} />
            <Route path="/services" component={Services} />
            <Route path="/services/:slug" component={ServiceDetail} />
            <Route path="/work" component={Work} />
            <Route path="/work/:slug" component={WorkDetail} />
            <Route path="/blog" component={Blog} />
            <Route path="/blog/:slug" component={BlogDetail} />
            <Route path="/contact" component={Contact} />
            <Route path="/help" component={Help} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/terms" component={Terms} />
            <Route path="/tool/audit/ttfb" component={TTFBAudit} />
            <Route component={NotFound} />
          </Switch>
        </RootLayout>
      </Route>
    </Switch>
      <Toaster />
      <CookieBanner />
    </HelmetProvider>
  );
}

export default App;
